<div class="flex flex-row gap-2" [siTooltip]="userOrgCode()" tooltipPosition="top">
    <si-avatar [altText]="userName()" [initials]="userInitials()" />
    @if (!showOnlyAvatar()) {
        <div class="flex flex-col ms-2">
            <p>{{ userName() }}</p>
            <p>
                <small class="text-secondary">{{ userMail() }}</small>
            </p>
        </div>
    }
</div>
